import { render, staticRenderFns } from "./deanButton.vue?vue&type=template&id=69775e9f&scoped=true"
import script from "./deanButton.vue?vue&type=script&lang=ts"
export * from "./deanButton.vue?vue&type=script&lang=ts"
import style0 from "./deanButton.vue?vue&type=style&index=0&id=69775e9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69775e9f",
  null
  
)

export default component.exports